import React from 'react'
import BillsList from '../../components/Payables/Bills/VendorBillList'
import VendorList from '../../components/Payables/Vendors/VendorList';
import { TabGroup } from '../../helpers/Tabs/TabGroup';
import { Tab } from '../../helpers/Tabs/Tab';

export default class PayablesTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    render(){
        return (
        <div>
            <div class="row">
                <div class="main-page-header-row col-md-12">
                    <div class="col-md-3 col-sm-6 col-xs-6">
                        <span class="main-page-header-title">Payables</span>
                    </div>
                </div>
            </div>
            <br />
            <TabGroup>
                <Tab title="bills">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="header col-md-6 col-sm-12 col-xs-12">
                                    <h4 class="title">Bills</h4>
                                    <p class="category">Complete list of all bills</p>
                                </div>
                                <BillsList />
                            </div>
                        </div>
                    </div>
                </Tab>
                <Tab title="vendors">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="header col-md-6 col-sm-12 col-xs-12">
                                    <h4 class="title">Vendors</h4>
                                    <p class="category">Complete list of all vendors</p>
                                </div>
                                <VendorList data={[]} filter={this.state.filter}/>
                            </div>
                        </div>
                    </div>
                </Tab>
            </TabGroup>
        </div>
        )
        }
    };



// WEBPACK FOOTER //
// app/views/Payables/Payables.jsx